import { ITripsModel } from "models/trips";
import { ReactNode, createContext, useContext, useState } from "react";
import CancelTripModal from "./CancelTripModal";
import CompleteTripModal from "./CompleteTripModal";

interface ITripAlertProps {
  showCancel: (trip: ITripsModel) => void;
  showComplete: (trip: ITripsModel) => void;
}

export const TripAlertContext = createContext<ITripAlertProps>(
  {} as ITripAlertProps
);

export const useTripAlertContext = () =>
  useContext<ITripAlertProps>(TripAlertContext);

interface IOpen {
  open: boolean;
  trip: ITripsModel | null;
}

export function TripAlertContextProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [openBan, setOpenBan] = useState<IOpen>({ open: false, trip: null });
  const [openActivate, setOpenActivate] = useState<IOpen>({
    open: false,
    trip: null,
  });

  const showCancel = (trip: ITripsModel) => setOpenBan({ open: true, trip });
  const showComplete = (trip: ITripsModel) =>
    setOpenActivate({ open: true, trip });

  const handleCloseBan = () => setOpenBan({ open: false, trip: null });
  const handleCloseActivate = () =>
    setOpenActivate({ open: false, trip: null });

  return (
    <TripAlertContext.Provider
      value={{
        showComplete,
        showCancel,
      }}
    >
      {openBan.trip && (
        <CancelTripModal
          open={openBan.open}
          trip={openBan.trip}
          handleClose={handleCloseBan}
        />
      )}

      {openActivate.trip && (
        <CompleteTripModal
          open={openActivate.open}
          trip={openActivate.trip}
          handleClose={handleCloseActivate}
        />
      )}
      {children}
    </TripAlertContext.Provider>
  );
}
